import { Loading } from 'notiflix/build/notiflix-loading-aio';
import { Notify } from 'notiflix/build/notiflix-notify-aio';


// Show loader function
export const showLoader = () => {
Loading.hourglass();
};

// Hide loader function
export const hideLoader = () => {
  Loading.remove();
};

// Loader component (if needed)
export const notifySuccess = (message)=>{
  Notify.success(message);
}

export const notify = (status, message) => {
  Notify[status](message);
}
export const notifyError = ( message) => {
  Notify.failure(message);
}